import { environment } from 'src/environments/environment';

export interface AgentConfig {
  key: string;
  name: string;
  route: string;
  webhookUrl: string;
  icon: string;
  description: string;
}

export const MEDIGI_AGENT: AgentConfig = {
  key: 'medigi',
  name: 'Dr. Medas',
  route: 'medigi',
  webhookUrl: `${environment.api_url_v1}/services/ai/agent`,
  icon: 'user',
  description: 'Unified assistant — data, support, ops, registration',
};

// Kept as an array so the (currently single-item) ai-agents shell sidebar
// can iterate it. When more agents are re-introduced, append here and the
// sidebar will auto-render them.
export const AGENTS: AgentConfig[] = [MEDIGI_AGENT];
